import { useQuery } from '@tanstack/react-query';
import { AlexaVisibilityRun } from '@blisspointmedia/bpm-types/dist/AlexaVisibility';
import { AlexaVisibilityLambdaFetch, awaitJSON } from '@src/utils/fetch-utils';
import { ACTIVE_RUN_STATUSES, RUN_POLL_INTERVAL_MS } from '../alexa-visibility-constants';

// Run history for a company, across every brand that's ever been tracked.
// Polls while the most recent run is still pending/running so the "Run
// Scrape" button's progress state and the run picker pick up completion
// without the user having to refresh.
export const useAlexaVisibilityRuns = (
  company: string
): ReturnType<typeof useQuery<AlexaVisibilityRun[]>> =>
  useQuery({
    meta: { suppressGlobalError: true },
    queryKey: ['alexaVisibilityRuns', company],
    queryFn: async (): Promise<AlexaVisibilityRun[]> => {
      const response = await AlexaVisibilityLambdaFetch('/runs', {
        method: 'GET',
        params: { company }
      });
      const runs = await awaitJSON<AlexaVisibilityRun[]>(response);
      return [...runs].sort(
        (a, b) => new Date(b.startedAt).getTime() - new Date(a.startedAt).getTime()
      );
    },
    enabled: Boolean(company),
    refetchInterval: query => {
      const latestRun = query.state.data?.[0];
      return latestRun && ACTIVE_RUN_STATUSES.has(latestRun.status) ? RUN_POLL_INTERVAL_MS : false;
    }
  });
